import { RouteComponentProps, withRouter } from 'react-router-dom';
import { RouteParams } from '../../../core/models/RouteHelper';
import MobileMatchReport from './MobileMatchReport';

interface OwnProps {}

export type Props = OwnProps & RouteComponentProps<RouteParams>;

export default withRouter(MobileMatchReport);
